"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DistributionType = exports.Currency = exports.AdjustmentType = exports.AdjustmentFileColumn = exports.AbacusStateActionName = void 0;
// General
// Abacus
let AbacusStateActionName = exports.AbacusStateActionName = /*#__PURE__*/function (AbacusStateActionName) {
  AbacusStateActionName["CloseBalance"] = "close_balance";
  AbacusStateActionName["UploadFile"] = "upload_file";
  return AbacusStateActionName;
}({});
let AdjustmentType = exports.AdjustmentType = /*#__PURE__*/function (AdjustmentType) {
  AdjustmentType["AccountExpense"] = "account expense";
  return AdjustmentType;
}({});
let Currency = exports.Currency = /*#__PURE__*/function (Currency) {
  Currency["AUD"] = "AUD";
  Currency["CAD"] = "CAD";
  Currency["CHF"] = "CHF";
  Currency["DKK"] = "DKK";
  Currency["EUR"] = "EUR";
  Currency["GBP"] = "GBP";
  Currency["JPY"] = "JPY";
  Currency["KRW"] = "KRW";
  Currency["NOK"] = "NOK";
  Currency["NZD"] = "NZD";
  Currency["SEK"] = "SEK";
  Currency["USD"] = "USD";
  return Currency;
}({});
let DistributionType = exports.DistributionType = /*#__PURE__*/function (DistributionType) {
  DistributionType["Digital"] = "digital";
  DistributionType["Physical"] = "physical";
  return DistributionType;
}({}); // Config
// Custom
let AdjustmentFileColumn = exports.AdjustmentFileColumn = /*#__PURE__*/function (AdjustmentFileColumn) {
  AdjustmentFileColumn["AccountId"] = "account_id";
  AdjustmentFileColumn["AccountName"] = "account_name";
  AdjustmentFileColumn["ActivityMonth"] = "activity_month";
  AdjustmentFileColumn["ActivityYear"] = "activity_year";
  AdjustmentFileColumn["AdjustmentType"] = "adjustment_type";
  AdjustmentFileColumn["Amount"] = "amount";
  AdjustmentFileColumn["ClientFacingComments"] = "client_facing_comments";
  AdjustmentFileColumn["ContractId"] = "contract_id";
  AdjustmentFileColumn["ContractName"] = "contract_name";
  AdjustmentFileColumn["Currency"] = "currency";
  AdjustmentFileColumn["DistributionType"] = "distribution_type";
  AdjustmentFileColumn["InternalNote"] = "internal_note";
  AdjustmentFileColumn["StatementMonth"] = "statement_month";
  AdjustmentFileColumn["StatementYear"] = "statement_year";
  AdjustmentFileColumn["UPC"] = "upc";
  return AdjustmentFileColumn;
}({});